import React from 'react';
import { Plus } from 'lucide-react';

interface MobileBottomBarProps {
  onAdd: () => void;
  viewMode: string;
}

export const MobileBottomBar: React.FC<MobileBottomBarProps> = ({ onAdd, viewMode }) => (
  <div className="sm:hidden fixed bottom-5 right-5 z-40">
    <button
      onClick={onAdd}
      className="w-14 h-14 rounded-full flex items-center justify-center active:scale-90"
      style={{
        backgroundColor: 'var(--accent-primary)',
        boxShadow: '0 4px 16px rgba(42, 157, 143, 0.35)',
        transition: 'transform 200ms cubic-bezier(0.16,1,0.3,1)',
      }}
      aria-label={viewMode === 'todo' ? 'New task' : 'New event'}
    >
      <Plus className="w-6 h-6 text-white" />
    </button>
  </div>
);
